<template>
    <section>
        <img class="bg" :src="'zq_pro/zkk/coupon/bg.png'|imgUrlFormat" alt="" />
        <section
            class="btn"
            :style="{'background-image': 'url(' + imgUrl + 'zq_pro/zkk/coupon/button.png' + ')'}"
            @click="conponBoxOpen"
        ></section>
        <!-- 校验新老用户，领取优惠券 -->
        <coupon-dialog ref="conponbox" title="请填写个人信息" confirmText="确认提交" :showCancel="false" @confirm='getUserToken'>
            <section class="content">
                <section class="item">
                    <input type="text" class="input" placeholder="请输入手机号码" v-model="phone">
                </section>
                <section class="item message-wrap">
                    <input type="text" class="input" placeholder="请输入验证码" v-model="verifyCode">
                    <section class="message" @click="sendSms">{{ msgSendTxt }}</section>
                </section>
            </section>
        </coupon-dialog>
        <!-- 领取成功跳转小程序 -->
        <coupon-dialog ref="minibox" title="" confirmText="前往使用" cancelText="暂不使用" :showTitle="false"  @cancal='miniBoxClose' @confirm='leaveTheEarth'>
            <section class="content_">
                <van-icon
                    class="icon"
                    name="checked"
                    color="#00C5A5"
                    size="138"
                />
                <p class="p">优惠券已领，请前往</p>
                <p class="p">省卡小程序优惠券中心查看</p>
            </section>
        </coupon-dialog>
    </section>
</template>

<script>
import { setToken, getPicUrl } from '@/utils/utils'
import { getUserToken, loginByPhone, queryOldLists } from '@/api/coupon'
import { sendSms } from '@/api/index'
import couponDialog from '@/components/couponDialog.vue'
export default {
    data() {
        return {
            imgUrl: '',
            show: false,
            resultShow: false,
            phone: '',
            verifyCode: '',
            msgSendStatus: true,
            msgSendTxt: '发送验证码',
            timer: null,
            productType: 8
        }
    },
    components: { couponDialog },
    created() {
        console.log(this.$route.query)
        this.imgUrl = getPicUrl()
    },
    mounted() {
    },
    methods: {
        conponBoxOpen() {
            this.$refs.conponbox.open()
        },
        conponBoxClose() {
            this.$refs.conponbox.close()
        },
        miniBoxOpen() {
            this.$refs.minibox.open()
        },
        miniBoxClose() {
            this.$refs.minibox.close()
        },
        async sendSms() {
            const that = this
            const { phone } = this
            if (!this.msgSendStatus) return
            if (!phone.length) return this.$toast('请输入手机号码')
            const reg = /^1[3-9]\d{9}$/g;
            const result = reg.test(this.phone);
            if (!result) return this.$toast("请输入正确格式的手机号")
            const res = await sendSms({ phone })
            if (res.data.code !== 200) return this.$dialog.alert({
                message: res.data.msg
            })
            if (res.data.code === 200) {
                this.$toast(res.data.msg)
                let time = 60
                this.msgSendStatus = false
                this.msgSendTxt = `${time}秒再试`

                this.timer = setInterval(function () {
                    if (time <= 0) {
                        that.msgSendStatus = true
                        that.msgSendTxt = '发送验证码'
                        clearInterval(that.timer)
                        return
                    }
                    that.msgSendTxt = `${time}秒再试`
                    that.sendStatus = false
                    time--
                }, 1000)
            }
        },
        // 老新客判断
        async getUserToken() {
            const { phone, verifyCode } = this
            if (!phone.length) return this.$toast('请输入手机号码')
            const reg = /^1[3-9]\d{9}$/g;
            const result = reg.test(this.phone);
            if (!result) return this.$toast("请输入正确格式的手机号")
            if (!verifyCode.length) return this.$toast('请输入验证码')
            const res = await getUserToken({ phone })
            if (res.data.code !== 200) return this.$dialog.alert({
                message: res.data.msg
            })
            if (res.data.code === 200) {
                if (res.data.data) {
                    this.loginByPhone(0)
                } else {
                    this.$dialog.confirm({
                        message: '活动暂时对老用户开放',
                        confirmButtonText: '去小程序',
                        confirmButtonColor: '#00C5A5'
                    }).then(()=> {
                        this.leaveTheEarth()
                    }).catch(() => {
                        console.log("点击了取消按钮噢")
                    })
                }
            }
        },
        // 登录领券
        async loginByPhone(type) {
            const latitude = ''
            const longitude = ''
            const productType = 8
            const { phone, verifyCode } = this
            if (!phone.length) return this.$toast('请输入手机号码')
            if (!verifyCode.length) return this.$toast('请输入验证码')
            const res = await loginByPhone({ phone, verifyCode, latitude, longitude, productType })
            if (res.data.code !== 200) return this.$dialog.alert({
                message: res.data.msg
            })
            if (res.data.code === 200) {
                // 老客
                if (type === 0) {
                    setToken(res.data.data.token)
                    this.queryOldLists()
                }
                // 新客
                if (type === 1) {
                    this.conponBoxClose()
                    this.miniBoxOpen()
                }
            }
        },
        // 获取老客优惠券
        async queryOldLists() {
            const haveCondition = 1
            const pageNum = 1
            const pageSize = 25
            const productType = 8
            const userType = 0
            const res = await queryOldLists({ haveCondition, pageNum, pageSize, productType, userType })
            if (res.data.code !== 200) return this.$dialog.alert({
                message: res.data.msg
            })
            if (res.data.code === 200) {
                this.conponBoxClose()
                if (res.data.data.list.length) {
                    this.miniBoxOpen()
                } else {
                    this.$toast('领取优惠券失败')
                }
            }
        },
        leaveTheEarth() {
            location.href = 'weixin://dl/business/?t=5o4T2fN28Sa'
        }
    }
}
</script>

<style lang="scss" scoped>
.bg {
    width: 100%;
}

.btn {
    position: absolute;
    top: 685px;
    left: calc((100% - 411px) / 2);
    z-index: 999;
    display: block;
    width: 411px;
    height: 121px;
    background-size: 411px 121px;
    background-repeat: no-repeat;
}


.content {
    padding: 48px 0;
    .item {
        display: flex;
        align-items: center;
        
        margin: 0 auto;
        margin-bottom: 32px;
        width: 544px;
        height: 88px;
        font-size: 32px;

        &:nth-last-of-type(1) {
            margin-bottom: 0;
        }
        .input {
            box-sizing: border-box;
            border-radius: 44px;
            border: 1px solid #EEEEEE;
            padding: 0 30px;
            width: 100%;
            height: 88px;
        }

        &.message-wrap {
            .input {
                width: calc(100% - 276px);
            }
            .message {
                flex: 0 0 276px;
                width: 276px;
                text-align: right;
                color: #00C5A5;
            }
        }
        
    }
}

.content_ {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 48px 0;
    .icon {
        margin: 0px auto 0 auto;
        width: 250px;
        height: 250px;
        text-align: center;
        line-height: 168px;
    }
    .p {
        font-size: 32px;
        line-height: 44px;
        text-align: center;
    }
}
</style>
